import * as React from 'react';
import { Loader2 } from 'lucide-react';

import { cn } from '@shared/utils/cn';

// Remplace CircularProgress
const Spinner = ({ className, ...props }: React.ComponentProps<typeof Loader2>) => (
  <Loader2
    aria-label="Chargement"
    className={cn('size-6 animate-spin text-primary', className)}
    role="status"
    {...props}
  />
);

export { Spinner };
